import allOtherQueryParams from "./allOtherQueryParams";

function getOfferUrl(baseOfferUrl: string): string {
    const cameFromOffersPage = typeof document.referrer === "string"
        && document.referrer.startsWith(baseOfferUrl);

    // If we were directed here from a special variant of the offer page,
    // we should direct the user back to that variant. Referrer includes query parameters,
    // so it would also include any tracking/referral params without additional inclusion.
    return cameFromOffersPage
        ? document.referrer
        : `${ baseOfferUrl }${ allOtherQueryParams("id") }`;
}

export default getOfferUrl;
